import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MDS_COLORS_INK_WEAK, MDS_COLORS_SKELETON_WEAK } from '@rappi/mustache-b2b-foundations';
import { InlineBox, ProfileOutlineIcon, Typography } from '@rappi/rests-commons-front';
import { useTranslation } from 'react-i18next';
export const AllyInformation = ({ allyName, allyLastName, email, id, idType, restaurantName }) => {
    const { t } = useTranslation();
    return (_jsx(InlineBox, { centerIcon: true, title: t('socialReason'), backgroundColor: MDS_COLORS_SKELETON_WEAK, customIcon: _jsx(ProfileOutlineIcon, { color: MDS_COLORS_INK_WEAK }), body: _jsxs(Typography, { component: "caption1", children: [allyName, " ", allyLastName, " | ", idType, " ", id, " | ", restaurantName, " | ", email] }) }));
};
